import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import getFeaturesFromGeoJson from '../utility/getFeaturesFromGeoJson'
import arrayIsNotEmpty from '../utility/arrayIsNotEmpty'
import { makeGetDatetime } from '../selectors/datetimeSelector'
import { makeGetData } from '../selectors/dataSelector'
import { makeGetDomain } from '../selectors/chartDomainSelector'
import { makeGetLayerRendered } from '../selectors/layerRenderedSelector'
import BrushZoomChart from './BrushZoomChart'
import Rainbow from 'rainbowvis.js'

const gradient = new Rainbow()
// gradient.setSpectrum('blue', 'cyan', 'yellow', 'red')
gradient.setSpectrum('#005EA5', '#1BD533', '#ABE2FB', '#EFB123', '#B2670A', '#660800')

const chartStyles = datetime => ({
  bar: {
    data: {
      // width: 5,
      strokeWidth: 0.5,
      strokeOpacity: 0.5,
      // fill: d => (d.value < 5 ? "green" : d.value < 15 ? "yellow" : "red")
      fill: d => `#${gradient.colourAt(d.value / 34 * 100)}`,
      // fill: "#00e1ff"
    }
  }
})

class WaterTemperatureBarChart extends PureComponent {
  render () {
    const { data, datetime, domain, render } = this.props
    const title = 'Lake TSS (300m)'

    if (!arrayIsNotEmpty(data) || !render) {
      return null
    }

    return (
      <BrushZoomChart
        data={data}
        title={title}
        chartStyles={chartStyles}
        datetime={datetime}
        domain={domain}
      />
    )
  }
}

const makeMapStateToProps = () => {
  const getDatetime = makeGetDatetime()
  const getData = makeGetData()
  const getDomain = makeGetDomain()
  const getLayerRendered = makeGetLayerRendered()

  const mapStateToProps = state => {
    const data = getData(state, 'WaterLakeTss', getFeaturesFromGeoJson, d => d.value >= 0)
    const datetime = getDatetime(state, 'WaterLakeTss')

    return {
      data,
      datetime,
      domain: getDomain(state, data, datetime),
      fetching: state.data.fetching,
      render: getLayerRendered(state, 'WaterLakeTss')
    }
  }
  return mapStateToProps
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {}
  }
}

export default connect(makeMapStateToProps, mapDispatchToProps)(
  WaterTemperatureBarChart
)



// WEBPACK FOOTER //
// ./src/charts/WaterLakeTssBarChart.js